import { React, useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import RemoveIcon from 'assets/icons/remove-icon'

import {
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarDivider,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle
} from '../../../Assessment/components/EcosystemData/style'
import { ThreatRemoveIconWrapper, ThreatToggleWrapper } from '../style'
import { HabitatContext } from 'providers/HabitatContext'

const HabitatsContentHeader = ({ isOpen, item, handleOpenRemoveModal, toggleAccordion, disabled }) => {
  const { defaultHabitatsOptions } = useContext(HabitatContext);
  const habitats =
    item.Level3HabitatId
      ? defaultHabitatsOptions.level3Habitats
      : item.Level2HabitatId
        ? defaultHabitatsOptions.level2Habitats
        : defaultHabitatsOptions.level1Habitats // Include level1Habitats handling

  const habitatItemId =
    item.Level3HabitatId
      ? item.Level3HabitatId
      : item.Level2HabitatId
        ? item.Level2HabitatId
        : item.Level1HabitatId // Include Level1HabitatId handling

  const name = habitats.find((element) => {
    return element.value === habitatItemId
  })

  return (
    <>
      <EcosystemHeaderNavbarWrapper isOpen={isOpen} data-test="habitats">
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle data-test="habitats-name">{name ? name.label : item.name}</EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <ThreatToggleWrapper isActive={isOpen}>
            <FormattedMessage id="expand" />
            {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
          </ThreatToggleWrapper>
          {!disabled && (
            <>
              <EcosystemHeaderNavbarDivider />
              <ThreatRemoveIconWrapper
                delete={true}
                data-test="remove-button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleOpenRemoveModal(item)
                }}
              >
                <RemoveIcon />
              </ThreatRemoveIconWrapper>
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
    </>
  )
}

export default HabitatsContentHeader